import { NgModule } from '@angular/core';
import { I_CONNECTION_AVAILABILITY_SERVICE } from '../common/i-connection-availability.service';
import { ConnectionAvailabilityBrowserService } from './connection-availability.browser.service';

@NgModule({
  providers: [{ provide: I_CONNECTION_AVAILABILITY_SERVICE, useClass: ConnectionAvailabilityBrowserService }],
})
export class ConnectionAvailabilityBrowserModule {}
